import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { Slider, SliderValue } from 'tdesign-react';

import styles from './index.module.less';

export interface IProps {
  onChange: (key: any) => void;
  value: number;
  defaultValue: number;
  label: string;
  min: number;
  max: number;
  marks: number[];
  disabled?: boolean;
}

const CustomAigcNumber: React.FC<IProps> = (props) => {
  const { onChange, value, defaultValue, label, min, max, marks, disabled = false } = props;
  const [count, setCount] = useState<SliderValue>(1);

  useEffect(() => {
    if (value) {
      setCount(value);
    }
  }, [value]);

  const handleSelect = (number: SliderValue) => {
    setCount(number);
    onChange(number as number);
  };

  return (
    <div className={classNames('custom-form-group', styles.container)} >
      <div className={styles.generateCount}>
        {label && <span className={styles.label}>{label}</span>}
        <Slider
          label
          defaultValue={defaultValue}
          min={min}
          max={max}
          marks={marks}
          inputNumberProps
          value={count}
          onChange={handleSelect}
          style={{ flex: 1 }}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default CustomAigcNumber;
